import React from "react";
import { DragDropContext, Droppable, DropResult } from "react-beautiful-dnd";

import { EnhancedTableBody } from "../EnhancedTableBody";
import { getReorderedItems } from "../../helpers/getReorderedItems";

import { SliderQuestionsTableBodyRow } from "./SliderQuestionsTableBodyRow";


import { IProps } from "./SliderQuestionsTable";
import useAuth from "../../routes/login/AuthContext";
import { useRetainAnswerToggle } from "../../hooks/useRetainAnswerToggle";

interface IExtendedProps extends IProps {
  setData: (question: any) => void;
  onSave: any;
  editDisabled: boolean;
}

export const SliderQuestionsTableBody: React.FC<IExtendedProps> = (props) => {
  const { isSuperAdminRead } = useAuth();
  const {toggleRetainAnswer, isLoading} = useRetainAnswerToggle(props.onSave);
  const onDragEnd = ({ destination, source }: DropResult) => {
    if (destination?.index === source.index) {
      return;
    }

    props.onReorder({
      type: "SLIDER",
      items: getReorderedItems({
        newIndex: destination?.index,
        oldIndex: source.index,
        items: props.questions,
      }),
    });
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable isDropDisabled={isSuperAdminRead()} droppableId="sliderQuestions">
        {(provided) => (
          <EnhancedTableBody
            {...provided.droppableProps}
            colSpan={6}
            ref={provided.innerRef}
            isLoading={props.isLoading}
          >
            {props.questions.map((question, idx) => (
              <SliderQuestionsTableBodyRow
                idx={idx}
                key={question.id}
                showTagColumn={props.showTagColumn}
                handleEdit={() => props.setData(question)}
                handleDelete={() => props.onRemove(question)}
                editDisabled={props.editDisabled}
                toggleRetainAnswer={() => toggleRetainAnswer(question)}
                isLoading={isLoading}
                {...question}
              />
            ))}
            {Boolean(props.questions.length) && provided.placeholder}
          </EnhancedTableBody>
        )}
      </Droppable>
    </DragDropContext>
  );
};
